import { BackButton as RaBackButton } from "ra-friendsofbabba";
import React from "react";

const BackButton = (props) => (
  <RaBackButton
    {...props}
    label="ra.action.back_to_project"
    to={`/executive-projects/${props?.record?.executive_project_id}/1`}
  />
);

export default BackButton;
